import { useMemo } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../store";
import { RoleCode } from "../../../lib/rbac/role.constants";
import {
  getTheHighestRole,
  toKnownRoleCodes,
} from "../../../lib/rbac/utils/role.utils";

export const useProfile = () => {
  const loginState = useSelector((state: RootState) => state.auth);

  const isNewUser = loginState.user?.new_user === 1 ? true : false;

  // Admin queued a fresh survey for this user — the earlier run must not surface.
  const isNewSurvey = Number(loginState.user?.new_survey) === 1;

  const roleCodes = useMemo(
    () => toKnownRoleCodes(loginState.roles?.map((role) => role.code) ?? []),
    [loginState.roles],
  );

  const highestRole = useMemo(() => {
    if (!roleCodes.length) return undefined;
    return getTheHighestRole(roleCodes);
  }, [roleCodes]);

  const hasRole = (role: RoleCode) => roleCodes.includes(role);

  const isCoach = roleCodes.includes(RoleCode.COACH);

  return {
    isNewUser,
    isNewSurvey,
    isCoach,
    hasRole,
    highestRole,
    roleCodes,
    ...loginState,
    isAuthenticated: !!loginState.token && !!loginState.user,
  };
};
